// import React, { useEffect, useState } from "react";
// import { useOutletContext } from "react-router-dom";
// import { Modal, Button } from "react-bootstrap";
// import { jwtDecode } from "jwt-decode";
// import "./ServitorSite.css";
// import ViewOrderDetails from "./ViewOrderDetails";

// const ServitorSite = () => {
//   // Get common data from the layout wrapper context.
//   const { servitor } = useOutletContext();

//   // Local state for orders and UI interactions.
//   const [orders, setOrders] = useState([]); // Now we use setOrders to store fetched orders.
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [blockedModal, setBlockedModal] = useState(false);
//   const [selectedCity, setSelectedCity] = useState("ALL");

//   // Helper functions to determine city and address from an order.
//   const getOrderCity = (order) => order.City || order.usercity || "Unknown";
//   const getOrderAddress = (order) =>
//     order.Address || order.useraddress || "Unknown";

//   // Fetch orders for this servitor.
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       if (
//         decodedToken.role === "servitor" &&
//         decodedToken.Id.startsWith("servitor-")
//       ) {
//         const servitorId = decodedToken.Id.split("-")[1];
//         fetch(`http://localhost:4001/orders/servitor/${servitorId}`)
//           .then((response) => response.json())
//           .then((orderData) => {
//             setOrders(orderData || []);
//           })
//           .catch((error) => {
//             console.error("Error fetching orders:", error);
//           });
//       }
//     }
//   }, []);

//   // Handlers for viewing order details.
//   const handleViewDetails = (order) => {
//     if (servitor?.approve_status === "Blocked") {
//       setBlockedModal(true);
//     } else {
//       setSelectedOrder(order);
//     }
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // Filter orders based on the selected city.
//   const filteredOrders = orders.filter((order) =>
//     selectedCity === "ALL" ? true : getOrderCity(order) === selectedCity
//   );

//   // Main content: either a pending message, the details view, or the orders list.
//   const mainContent =
//     servitor.approve_status === "Pending" ? (
//       <div className="servitorsite-message-box">
//         <p>
//           Welcome to HelpNao, please wait for your account approval to get
//           orders.
//         </p>
//       </div>
//     ) : selectedOrder ? (
//       <ViewOrderDetails
//         order={selectedOrder}
//         onBack={handleBackToOrders}
//         servitor={servitor}
//       />
//     ) : (
//       <>
//         <h2 className="servitorsite-welcome-heading">
//           Welcome to HelpNao Servitor Site
//         </h2>
//         <div className="servitorsite-city-filter">
//           <label htmlFor="citySelect">Filter by City: </label>
//           <select
//             id="citySelect"
//             value={selectedCity}
//             onChange={(e) => setSelectedCity(e.target.value)}
//           >
//             <option value="ALL">ALL</option>
//             <option value="Barishal">Barishal</option>
//             <option value="Chattogram">Chattogram</option>
//             <option value="Dhaka">Dhaka</option>
//             <option value="Khulna">Khulna</option>
//             <option value="Rajshahi">Rajshahi</option>
//             <option value="Rangpur">Rangpur</option>
//             <option value="Mymensingh">Mymensingh</option>
//             <option value="Sylhet">Sylhet</option>
//           </select>
//         </div>

//         <div className="servitorsite-orders-section">
//           <h3>Orders</h3>
//           <div className="servitorsite-order-cards">
//             {filteredOrders.length > 0 ? (
//               filteredOrders.map((order, index) => (
//                 <div className="servitorsite-order-card">
//                   {/* Status label always in top-right */}
//                   <div className="servitorsite-order-status">
//                     <span
//                       className={`servitorsite-status-label ${order.status.toLowerCase()}`}
//                     >
//                       {order.status}
//                     </span>
//                     <span>
//                       {order.deadline}
//                     </span>
//                   </div>

//                   {/* Main content that can grow */}
//                   <div className="servitorsite-order-card-content">
//                     <h4>Order Number: {order.order_number}</h4>
//                     <p>
//                       Service:{" "}
//                       {order.Service?.services_name ||
//                         "Service information not available"}
//                     </p>
//                     <p>Price: ${order.price}</p>
//                     <p>Date: {new Date(order.date).toLocaleDateString()}</p>
//                     <p>Time: {order.time}</p>
//                     <p>City: {getOrderCity(order)}</p>
//                     <p>Address: {getOrderAddress(order)}</p>
//                   </div>

//                   {/* Button pinned to the bottom by Flexbox */}
//                   <button
//                     className="servitorsite-view-details-btn"
//                     onClick={() => handleViewDetails(order)}
//                   >
//                     View Details
//                   </button>
//                 </div>
//               ))
//             ) : (
//               <p>No orders matching your service yet!</p>
//             )}
//           </div>
//         </div>
//       </>
//     );

//   return (
//     <>
//       {mainContent}
//       <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Your account has been <span style={{ color: "red" }}>Blocked</span>{" "}
//           due to certain issues. Please contact HelpNao support for assistance.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBlockedModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default ServitorSite;


// ***** Check All okay and working (25-6-25) ***** //

// import React, { useEffect, useState } from "react";
// import { useNavigate , useOutletContext } from "react-router-dom";
// import { Modal, Button } from "react-bootstrap";
// import { jwtDecode } from "jwt-decode";

// import "./ServitorSite.css";
// import ViewOrderDetails from "./ViewOrderDetails";
// import CountdownTimer from "../../Components/CountDownTimer/CountdownTimer";

// const ServitorSite = () => {
//   const { servitor } = useOutletContext();
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [blockedModal, setBlockedModal] = useState(false);
//   const [selectedCity, setSelectedCity] = useState("ALL");
//   const navigate = useNavigate();

//   const getOrderCity = (order) => order.City || order.usercity || "Unknown";
//   const getOrderAddress = (order) => order.Address || order.useraddress || "Unknown";

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       if (
//         decodedToken.role === "servitor" &&
//         decodedToken.Id.startsWith("servitor-")
//       ) {
//         const servitorId = decodedToken.Id.split("-")[1];
//         fetch(`http://localhost:4001/orders/servitor/${servitorId}`)
//           .then((response) => response.json())
//           .then((orderData) => {
//             const ordersArray = Array.isArray(orderData) ? orderData : [orderData];
//             // setOrders(orderData || []);
//             setOrders(ordersArray);
//           })
//           .catch((error) => {
//             console.error("Error fetching orders:", error);
//           });
//       }
//     }
//   }, []);

//   const handleViewDetails = (order) => {
//     if (servitor?.approve_status === "Blocked") {
//       setBlockedModal(true);
//     } else {
//       // setSelectedOrder(order);
//       navigate(`/servitor/orders/${order.order_number}`);
//     }
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // const filteredOrders = orders.filter((order) =>
//   //   selectedCity === "ALL" ? true : getOrderCity(order) === selectedCity
//   // );

//   const filteredOrders = orders.filter((order) =>
//     order && order.status && (selectedCity === "ALL" ? true : getOrderCity(order) === selectedCity)
//   );

  
//   // Conditionally render main content
//   let mainContent = null;

//   if (servitor.approve_status === "Pending") {
//     mainContent = (
//       <div className="servitorsite-message-box">
//         <p>Welcome to HelpNao, please wait for your account approval to get orders.</p>
//       </div>
//     );
//   } else if (selectedOrder) {
//     mainContent = (
//       <ViewOrderDetails
//         order={selectedOrder}
//         onBack={handleBackToOrders}
//         servitor={servitor}
//       />
//     );
//   } else {
//     mainContent = (
//       <>
//         <h2 className="servitorsite-welcome-heading">
//           Welcome to HelpNao Servitor Site
//         </h2>

//         <div className="servitorsite-city-filter">
//           <label htmlFor="citySelect">Filter by City: </label>
//           <select
//             id="citySelect"
//             value={selectedCity}
//             onChange={(e) => setSelectedCity(e.target.value)}
//           >
//             <option value="ALL">ALL</option>
//             <option value="Barishal">Barishal</option>
//             <option value="Chattogram">Chattogram</option>
//             <option value="Dhaka">Dhaka</option>
//             <option value="Khulna">Khulna</option>
//             <option value="Rajshahi">Rajshahi</option>
//             <option value="Rangpur">Rangpur</option>
//             <option value="Mymensingh">Mymensingh</option>
//             <option value="Sylhet">Sylhet</option>
//           </select>
//         </div>

//         <div className="servitorsite-orders-section">
//           <h3>Orders</h3>
//           <div className="servitorsite-order-cards">
//             {filteredOrders.length > 0 ? (
//               filteredOrders.map((order) => (
//                 <div
//                   className="servitorsite-order-card"
//                   key={order.order_number}
//                 >
//                   {/* Top-right: status label + countdown */}
//                   <div className="servitorsite-order-status">
//                     {/* <span className={`servitorsite-status-label ${order.status.toLowerCase()}`}>
//                       {order.status}
//                     </span> */}
//                     <span
//                       className={`servitorsite-status-label ${
//                         order.status?.toLowerCase() || "unknown"
//                       }`}
//                     >
//                       {order.status || "Unknown"}
//                     </span>

//                     {/* Countdown under the status label with some spacing */}
//                     {/* <div className="servitorsite-countdown-wrapper">
//                       <CountdownTimer
//                         dueDate={order.deadline || order.date}
//                         status={order.status}
//                         className="servitorsite-countdown-timer-pill"
//                       />
//                     </div> */}
//                   </div>

//                   {/* Main content area */}
//                   <div className="servitorsite-order-card-content">
//                     <h4>Order Number: {order.order_number}</h4>
//                     <p>
//                       <strong>Service:{" "}</strong>
//                       {order.Service?.services_name ||
//                         "Service information not available"}
//                     </p>
//                     <p><strong>Price:</strong> {order.price} Tk.</p>
//                     <p><strong>Date:</strong> {new Date(order.date).toLocaleDateString()}</p>
//                     <p><strong>Time:</strong> {order.time}</p>
//                     <p><strong>City:</strong> {getOrderCity(order)}</p>
//                     <p><strong>Address:</strong> {getOrderAddress(order)}</p>

//                     <div className="servitorsite-countdown-wrapper">
//                       <CountdownTimer
//                         dueDate={order.deadline || order.date}
//                         status={order.status}
//                         className="servitorsite-countdown-timer-pill"
//                       />
//                     </div>
//                   </div>

//                   <button
//                     className="servitorsite-view-details-btn"
//                     onClick={() => handleViewDetails(order)}
//                   >
//                     View Details
//                   </button>
//                 </div>
//               ))
//             ) : (
//               <p>No orders matching your service yet!</p>
//             )}
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       {mainContent}

//       {/* Blocked modal */}
//       <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Account Blocked</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Your account has been <span style={{ color: "red" }}>Blocked</span> due to certain
//           issues. Please contact HelpNao support for assistance.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBlockedModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default ServitorSite;

// ***** Upper code checked All okay (25-6-25) ***** //







// ***** Add Translator EN BN (25-6-25) ***** //

// import React, { useEffect, useState } from "react";
// import { useNavigate , useOutletContext } from "react-router-dom";
// import { Modal, Button } from "react-bootstrap";
// import { jwtDecode } from "jwt-decode";
// import { useTranslation } from "react-i18next";
// import "./ServitorSite.css";
// import ViewOrderDetails from "./ViewOrderDetails";
// import CountdownTimer from "../../Components/CountDownTimer/CountdownTimer";

// const ServitorSite = () => {
//   const { t } = useTranslation("servitor");
//   const { servitor } = useOutletContext();
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [blockedModal, setBlockedModal] = useState(false);
//   const [selectedCity, setSelectedCity] = useState("ALL");
//   const navigate = useNavigate();

//   const getOrderCity = (order) => order.City || order.usercity || "Unknown";
//   const getOrderAddress = (order) => order.Address || order.useraddress || "Unknown";

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       if (
//         decodedToken.role === "servitor" &&
//         decodedToken.Id.startsWith("servitor-")
//       ) {
//         const servitorId = decodedToken.Id.split("-")[1];
//         fetch(`http://localhost:4001/orders/servitor/${servitorId}`)
//           .then((response) => response.json())
//           .then((orderData) => {
//             const ordersArray = Array.isArray(orderData) ? orderData : [orderData];
//             // setOrders(orderData || []);
//             setOrders(ordersArray);
//           })
//           .catch((error) => {
//             console.error("Error fetching orders:", error);
//           });
//       }
//     }
//   }, []);

//   const handleViewDetails = (order) => {
//     if (servitor?.approve_status === "Blocked") {
//       setBlockedModal(true);
//     } else {
//       // setSelectedOrder(order);
//       navigate(`/servitor/orders/${order.order_number}`);
//     }
//   };

//   const handleBackToOrders = () => {
//     setSelectedOrder(null);
//   };

//   // const filteredOrders = orders.filter((order) =>
//   //   selectedCity === "ALL" ? true : getOrderCity(order) === selectedCity
//   // );

//   const filteredOrders = orders.filter((order) =>
//     order && order.status && (selectedCity === "ALL" ? true : getOrderCity(order) === selectedCity)
//   );

  
//   // Conditionally render main content
//   let mainContent = null;

//   if (servitor.approve_status === "Pending") {
//     mainContent = (
//       <div className="servitorsite-message-box">
//         {/* <p>Welcome to HelpNao, please wait for your account approval to get orders.</p> */}
//         <p>{t("servitorSite.pendingMessage")}</p>
//       </div>
//     );
//   } else if (selectedOrder) {
//     mainContent = (
//       <ViewOrderDetails
//         order={selectedOrder}
//         onBack={handleBackToOrders}
//         servitor={servitor}
//       />
//     );
//   } else {
//     mainContent = (
//       <>
//         <h2 className="servitorsite-welcome-heading">
//           {/* Welcome to HelpNao Servitor Site */}
//           {t("servitorSite.welcome")}
//         </h2>

//         <div className="servitorsite-city-filter">
//           {/* <label htmlFor="citySelect">Filter by City: </label> */}
//           <label htmlFor="citySelect">{t("servitorSite.filterByCity")}: </label>
//           <select
//             id="citySelect"
//             value={selectedCity}
//             onChange={(e) => setSelectedCity(e.target.value)}
//             aria-label={t("servitorSite.filterByCity")}
//           >
//             {/* <option value="ALL">ALL</option>
//             <option value="Barishal">Barishal</option>
//             <option value="Chattogram">Chattogram</option>
//             <option value="Dhaka">Dhaka</option>
//             <option value="Khulna">Khulna</option>
//             <option value="Rajshahi">Rajshahi</option>
//             <option value="Rangpur">Rangpur</option>
//             <option value="Mymensingh">Mymensingh</option>
//             <option value="Sylhet">Sylhet</option> */}

//             <option value="ALL">{t("servitorSite.allCities")}</option> {/* NEW: Translated */}
//             <option value="Barishal">{t("servitorSite.cities.Barishal")}</option> {/* NEW: Translated */}
//             <option value="Chattogram">{t("servitorSite.cities.Chattogram")}</option> {/* NEW: Translated */}
//             <option value="Dhaka">{t("servitorSite.cities.Dhaka")}</option> {/* NEW: Translated */}
//             <option value="Khulna">{t("servitorSite.cities.Khulna")}</option> {/* NEW: Translated */}
//             <option value="Rajshahi">{t("servitorSite.cities.Rajshahi")}</option> {/* NEW: Translated */}
//             <option value="Rangpur">{t("servitorSite.cities.Rangpur")}</option> {/* NEW: Translated */}
//             <option value="Mymensingh">{t("servitorSite.cities.Mymensingh")}</option> {/* NEW: Translated */}
//             <option value="Sylhet">{t("servitorSite.cities.Sylhet")}</option> {/* NEW: Translated */}
//           </select>
//         </div>

//         <div className="servitorsite-orders-section">
//           {/* <h3>Orders</h3> */}
//           <h3>{t("servitorSite.ordersSection")}</h3>
//           <div className="servitorsite-order-cards">
//             {filteredOrders.length > 0 ? (
//               filteredOrders.map((order) => (
//                 <div
//                   className="servitorsite-order-card"
//                   key={order.order_number}
//                 >
//                   {/* Top-right: status label + countdown */}
//                   <div className="servitorsite-order-status">
//                     {/* <span className={`servitorsite-status-label ${order.status.toLowerCase()}`}>
//                       {order.status}
//                     </span> */}
//                     <span
//                       className={`servitorsite-status-label ${
//                         order.status?.toLowerCase() || "unknown"
//                       }`}
//                     >
//                       {/* {order.status || "Unknown"} */}
//                        {order.status ? t(`status.${order.status.toLowerCase()}`, order.status) : "Unknown"} {/* NEW: Translated status */}
//                     </span>

//                     {/* Countdown under the status label with some spacing */}
//                     {/* <div className="servitorsite-countdown-wrapper">
//                       <CountdownTimer
//                         dueDate={order.deadline || order.date}
//                         status={order.status}
//                         className="servitorsite-countdown-timer-pill"
//                       />
//                     </div> */}
//                   </div>

//                   {/* Main content area */}
//                   <div className="servitorsite-order-card-content">
//                     <h4>Order Number: {order.order_number}</h4>
//                     <p>
//                       {/* <strong>Service:{" "}</strong> */}
//                       <strong>{t("servitorSite.service")}: </strong>
//                       {order.Service?.services_name ||
//                         "Service information not available"}
//                     </p>
//                     {/* <p><strong>Price:</strong> {order.price} Tk.</p>
//                     <p><strong>Date:</strong> {new Date(order.date).toLocaleDateString()}</p>
//                     <p><strong>Time:</strong> {order.time}</p>
//                     <p><strong>City:</strong> {getOrderCity(order)}</p>
//                     <p><strong>Address:</strong> {getOrderAddress(order)}</p> */}

//                     <p><strong>{t("servitorSite.price")}: </strong> {order.price} Tk.</p> {/* NEW: Translated */}
//                     <p><strong>{t("servitorSite.date")}: </strong> {new Date(order.date).toLocaleDateString()}</p> {/* NEW: Translated */}
//                     <p><strong>{t("servitorSite.time")}: </strong> {order.time}</p> {/* NEW: Translated */}
//                     <p><strong>{t("servitorSite.city")}: </strong> {getOrderCity(order)}</p> {/* NEW: Translated */}
//                     <p><strong>{t("servitorSite.address")}: </strong> {getOrderAddress(order)}</p> {/* NEW: Translated */}

//                     <div className="servitorsite-countdown-wrapper">
//                       <CountdownTimer
//                         dueDate={order.deadline || order.date}
//                         status={order.status}
//                         className="servitorsite-countdown-timer-pill"
//                       />
//                     </div>
//                   </div>

//                   <button
//                     className="servitorsite-view-details-btn"
//                     onClick={() => handleViewDetails(order)}
//                     aria-label={t("servitorSite.viewDetails")}
//                   >
//                     {/* View Details */}
//                     {t("servitorSite.viewDetails")}
//                   </button>
//                 </div>
//               ))
//             ) : (
//               // <p>No orders matching your service yet!</p>
//               <p>{t("servitorSite.noOrders")}</p>
//             )}
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       {mainContent}

//       {/* Blocked modal */}
//       <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
//         <Modal.Header closeButton>
//           {/* <Modal.Title>Account Blocked</Modal.Title> */}
//           <Modal.Title>{t("servitorSite.blockedModalTitle")}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* Your account has been <span style={{ color: "red" }}>Blocked</span> due to certain
//           issues. Please contact HelpNao support for assistance. */}

//           dangerouslySetInnerHTML={{ __html: t("servitorSite.blockedModalBody") }}

//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBlockedModal(false)}>
//             {/* Close */}
//             {t("servitorSite.close")}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default ServitorSite;
















import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import "./ServitorSite.css";
import CountdownTimer from "../../Components/CountDownTimer/CountdownTimer";
import { URL } from "../../config";
import Loader from "../../Components/LoaderSpin/Loader";
import { formatDateLong } from "../dateTimefrontpart";

const PRICE_OPTIONS = [
  { key: "ALL", label: "All", min: null, max: null },
  { key: "500-1000", label: "500-1000", min: 500, max: 1000 },
  { key: "1000-1500", label: "1000-1500", min: 1000, max: 1500 },
  { key: "1500-2000", label: "1500-2000", min: 1500, max: 2000 },
  { key: "2000-3000", label: "2000-3000", min: 2000, max: 3000 },
  { key: "3000+", label: "3000+", min: 3000, max: null },
];

const ServitorSite = () => {
  const { t } = useTranslation("servitor");
  const { servitor } = useOutletContext();
  const [orders, setOrders] = useState([]);
  const [blockedModal, setBlockedModal] = useState(false);

  // Filters
  const [divisions, setDivisions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState(""); // division Id
  const [selectedAreaId, setSelectedAreaId] = useState(""); // area Id
  const [priceKey, setPriceKey] = useState("ALL");

  // Mapped names (city/area names sent to backend)
  const selectedCityName = useMemo(() => {
    const d = divisions.find((x) => String(x.Id) === String(selectedCityId));
    return d?.name || "";
  }, [divisions, selectedCityId]);

  const selectedAreaName = useMemo(() => {
    const a = areas.find((x) => String(x.Id) === String(selectedAreaId));
    return a?.name || "";
  }, [areas, selectedAreaId]);

  // Pagination + loading
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const sentinelRef = useRef(null);

  const navigate = useNavigate();

  const getOrderCity = (order) => order.City || order.usercity || "Unknown";
  const getOrderArea = (order) => order.Area || order.userarea || "—";
  const getOrderAddress = (order) => order.Address || order.useraddress || "Unknown";

  // Get servitorId from token
  const servitorId = useMemo(() => {
    const token = localStorage.getItem("token");
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      if (decoded.role === "servitor" && decoded.Id?.startsWith?.("servitor-")) {
        return decoded.Id.split("-")[1];
      }
      return null;
    } catch {
      return null;
    }
  }, []);

  // Load divisions
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${URL}/locations/divisions?countryCode=BD`);
        const data = await res.json();
        setDivisions(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Failed to load divisions:", e);
        setDivisions([]);
      }
    })();
  }, []);

  // Load areas when city/division changes
  useEffect(() => {
    (async () => {
      if (!selectedCityId) {
        setAreas([]);
        setSelectedAreaId("");
        return;
      }
      try {
        const res = await fetch(
          `${URL}/locations/areas?divisionId=${selectedCityId}`
        );
        const data = await res.json();
        setAreas(Array.isArray(data) ? data : []);
        setSelectedAreaId("");
      } catch (e) {
        console.error("Failed to load areas:", e);
        setAreas([]);
        setSelectedAreaId("");
      }
    })();
  }, [selectedCityId]);

  // Reset pagination when filters change
  useEffect(() => {
    setPage(1);
    setOrders([]);
    setHasMore(true);
  }, [selectedCityName, selectedAreaName, priceKey]);

  const currentPrice = useMemo(() => PRICE_OPTIONS.find((x) => x.key === priceKey) || PRICE_OPTIONS[0], [priceKey]);

  const fetchPage = useCallback(async () => {
    if (!servitorId || !hasMore) return;

    const base = `${URL}/orders/servitor/${servitorId}`;
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", "15");

    if (selectedCityName) params.set("city", selectedCityName);
    if (selectedAreaName) params.set("area", selectedAreaName);
    if (currentPrice.min) params.set("priceMin", String(currentPrice.min));
    if (currentPrice.max) params.set("priceMax", String(currentPrice.max));

    try {
      if (page === 1) setInitialLoading(true);
      else setLoadingMore(true);

      const res = await fetch(`${base}?${params.toString()}`);
      const json = await res.json();

      const incoming = Array.isArray(json?.data) ? json.data : (Array.isArray(json) ? json : []);
      setOrders((prev) => (page === 1 ? incoming : [...prev, ...incoming]));
      setHasMore(Boolean(json?.hasMore));
    } catch (e) {
      console.error("Error fetching orders:", e);
      setHasMore(false);
    } finally {
      setInitialLoading(false);
      setLoadingMore(false);
    }
  }, [servitorId, page, selectedCityName, selectedAreaName, currentPrice.min, currentPrice.max, hasMore]);

  // First load + subsequent page loads on page change
  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  // Infinite scroll
  useEffect(() => {
    if (!sentinelRef.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingMore && hasMore && !initialLoading) {
          setPage((p) => p + 1);
        }
      },
      { rootMargin: "200px" }
    );
    obs.observe(sentinelRef.current);
    return () => obs.disconnect();
  }, [loadingMore, hasMore, initialLoading]);

  const handleViewDetails = (order) => {
    if (servitor?.approve_status === "Blocked") setBlockedModal(true);
    else navigate(`/servitor/orders/${order.order_number}`);
  };

  // UI
  if (servitor?.approve_status === "Pending") {
    return (
      <div className="servitorsite-message-box">
        {t("servitorSite.pendingMessage")}
      </div>
    );
  }

  return (
    <>
    <Loader show={initialLoading} />
      {/* <h2 className="servitorsite-welcome-heading">{t("servitorSite.welcome")}</h2> */}

      {/* Filters */}
      <div className="servitorsite-filter-row">
        {/* City */}
        <div className="servitorsite-filter">
          <label>{t("servitorSite.filterByCity")}</label>
          <select
            value={selectedCityId}
            onChange={(e) => setSelectedCityId(e.target.value)}
            aria-label={t("servitorSite.filterByCity")}
          >
            <option value="">{t("servitorSite.allCities")}</option>
            {divisions.map((d) => (
              <option key={d.Id} value={d.Id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>

        {/* Area */}
        <div className="servitorsite-filter">
          <label>{t("servitorSite.searchbyarea", "Area")}</label>
          <select
            value={selectedAreaId}
            onChange={(e) => setSelectedAreaId(e.target.value)}
            disabled={!selectedCityId}
            aria-label={t("servitorSite.searchbyarea", "Area")}
          >
            <option value="">{selectedCityId ? t("servitorSite.allAreas", "All Areas") : t("servitorSite.selectCityFirst", "Select City first")}</option>
            {areas.map((a) => (
              <option key={a.Id} value={a.Id}>
                {a.name}
              </option>
            ))}
          </select>
        </div>

        {/* Price */}
        <div className="servitorsite-filter">
          <label>{t("servitorSite.priceRange", "Price Range")}</label>
          <select value={priceKey} onChange={(e) => setPriceKey(e.target.value)}>
            {PRICE_OPTIONS.map((p) => (
              <option key={p.key} value={p.key}>
                {p.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Orders */}
      <div className="servitorsite-orders-section">
        <h3>{t("servitorSite.ordersSection")}</h3>

        {initialLoading && (
          <div className="servitorsite-loader">
            <Spinner animation="border" role="status" />
          </div>
        )}

        {!initialLoading && orders.length === 0 && (
          <p>{t("servitorSite.noOrders")}</p>
        )}

        <div className="servitorsite-order-cards">
          {orders.map((order) => (
            <div className="servitorsite-order-card" key={order.order_number}>
              <div className="servitorsite-order-status">
                <span className={`servitorsite-status-label ${(order.status || "unknown").toLowerCase()}`}>
                  {order.status ? t(`status.${order.status.toLowerCase()}`, order.status) : "Unknown"}
                </span>
              </div>

              <div className="servitorsite-order-card-content">
                <h4>Order Number: {order.order_number}</h4>

                <p>
                  <strong>{t("servitorSite.service")}: </strong>
                  {order.Service?.services_name || "Service information not available"}
                </p>

                <p><strong>{t("servitorSite.price")}: </strong> {order.price} Tk.</p>
                {/* <p><strong>{t("servitorSite.date")}: </strong> {new Date(order.date).toLocaleDateString()}</p> */}
                <p><strong>{t("servitorSite.date")}: </strong> {order?.date ? formatDateLong(order.date) : "TBD"}</p>
                <p><strong>{t("servitorSite.time")}: </strong> {order.time}</p>
                <p><strong>{t("servitorSite.city")}: </strong> {getOrderCity(order)}</p>
                <p><strong>{t("servitorSite.area", "Area")}: </strong> {getOrderArea(order)}</p>
                <p><strong>{t("servitorSite.address")}: </strong> {getOrderAddress(order)}</p>

                <div className="servitorsite-countdown-wrapper">
                  <CountdownTimer
                    dueDate={order.deadline || order.date}
                    status={order.status}
                    className="servitorsite-countdown-timer-pill"
                  />
                </div>
              </div>

              <button
                className="servitorsite-view-details-btn"
                onClick={() => handleViewDetails(order)}
                aria-label={t("servitorSite.viewDetails")}
              >
                {t("servitorSite.viewDetails")}
              </button>
            </div>
          ))}
        </div>

        {/* Infinite scroll sentinel */}
        {hasMore && !initialLoading && (
          <div ref={sentinelRef} className="servitorsite-sentinel">
            {loadingMore && (
              <div className="servitorsite-loader">
                <Spinner animation="border" role="status" />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Blocked modal */}
      <Modal show={blockedModal} onHide={() => setBlockedModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("servitorSite.blockedModalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body dangerouslySetInnerHTML={{ __html: t("servitorSite.blockedModalBody") }} />
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBlockedModal(false)}>
            {t("servitorSite.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServitorSite;
